module.exports = __webpack_public_path__ + "static/media/iq.58949f0e.svg";